import { wsService } from "./wsService";

import sections from "@/constants/sections";

const section = sections.SECTION_NEWS;
const my_section = "my-news";

const CONTENT_TYPES = {
  pdf: "application/pdf",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  webp: "image/webp",
  gif: "image/gif",
  mp4: "video/mp4",
  webm: "video/webm",
};

// Administrar: tambien trae borradores y cuantos leyeron. param: { offset } -> result: { list, total }
function filter(param = {}) {
  return wsService.make_post_request(section + "/list", param);
}

function create(formData) {
  return wsService.make_post_request(section + "/create", formData);
}

function update(formData) {
  return wsService.make_post_request(section + "/update", formData);
}

function remove(id) {
  return wsService.make_delete_request(section + "/delete", { id });
}

// Lo publicado, para cualquier usuario. param: { offset } -> result: { list, total }
function myFilter(param = {}) {
  return wsService.make_post_request(my_section + "/list", param);
}

// result: { count, latest }
function unread() {
  return wsService.make_get_request(my_section + "/unread");
}

function readAll() {
  return wsService.make_post_request(my_section + "/read-all", {});
}

// Los errores tambien llegan como binario: un JSON chico con status false no es el archivo
function fileResponse(response, attachment) {
  if (Object.prototype.toString.call(response) != "[object ArrayBuffer]") return response;

  if (response.byteLength < 1024) {
    try {
      const json = JSON.parse(new TextDecoder().decode(response));
      if (json && json.status === false) return json;
    } catch (e) {
      // No es JSON: es el archivo
    }
  }
  return { status: true, blob: new Blob([response], { type: CONTENT_TYPES[attachment.file_type] || "application/octet-stream" }) };
}

// -> { status, blob }
function file(attachment) {
  return wsService.make_get_request(my_section + "/file/" + attachment.id, { responseType: "arraybuffer" }).then((response) => fileResponse(response, attachment));
}

export const newsService = {
  section,
  filter,
  create,
  update,
  remove,
  myFilter,
  unread,
  readAll,
  file,
};
